export default "__VITE_ASSET__181c5b82__"